import React from "react";

import GroupsDataTable from "./GroupsDataTable";

const GroupsPage = () => {
    return (
        <div className="sub-content">
            <GroupsDataTable />
        </div>
    );
};

export default GroupsPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/groups/GroupsPage.js